import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { helpersMixin } from "@/utils";

import { catalog } from './modules/catalog.module';
import { modals } from './modules/modals.module';
import { powerbox } from './modules/powerbox.module';
import { interchange } from './modules/interchange.module';
import { labor } from './modules/labor.module';
import { parts } from './modules/parts.module';
import { settings } from './modules/settings.module';
import { spinner } from './modules/spinner.module';
import { snackbar } from './modules/snackbar.module';
import { vehicle } from './modules/vehicle.module';
import { C2C } from './modules/C2C.module';

Vue.use(Vuex);
Vue.mixin(helpersMixin)

// Localstorage: settingsStorage
const settingsStorage = {
  key: process.env.VUE_APP_LOCALSTORAGE_SETTINGS,
  reducer: state => ({
    partsResultPage: state.settings.partsResultPage,
    partsResultsAllines: state.settings.partsResultsAllines,
    displayCompatibilityMessage: state.settings.displayCompatibilityMessage,
    skin: state.settings.skin
  }),
  storage: window.localStorage
};

// Localstorage: DataStorage
const DataStorage = {
  key: process.env.VUE_APP_LOCALSTORAGE_DATA,
  reducer: state => ({
    years: state.vehicle.years,
    vehicles: state.vehicle.vehicles,
    categories: state.catalog.categories,
    selectedVehicle: state.vehicle.selectedVehicle,
    partsResultsAlllines: state.parts.partsResultsAlllines,
    interchangeResults: state.interchange.interchangeResults,
    groupsBasket: state.parts.groupsBasket,
    partsBasket: state.parts.partsBasket,
    partListBasket: state.parts.partListBasket,
    uniquepartsDescriptions: state.parts.uniquepartsDescriptions,
    specificConditionsQuestions: state.parts.specificConditionsQuestions,
    parts: {
      pagination: state.parts.pagination,
      groups: state.parts.groups
    },
    interchange: {
      interChangeNum: state.interchange.interChangeNum,
      pagination: state.interchange.pagination,
      groups: state.interchange.groups
    },
  }),
  storage: window.localStorage
};

// Import this object inside module actions that trigger another module action
export const rootAction = { root: true }

export const store = new Vuex.Store({
  plugins: [
    // Persists vuex state in Localstorage

    createPersistedState(settingsStorage),
    createPersistedState(DataStorage)
  ],
  modules: {
    C2C,
    snackbar,
    spinner,
    modals,
    vehicle,
    catalog,
    powerbox,
    parts,
    labor,
    settings,
    interchange
  }
})
